import { VssService } from "VSS/Platform/Context";

export interface IReleaseProgressBreadCrumbService extends VssService {
    setBreadcrumbs: (releaseLandingPageUrl: string, releaseDefinitionName?: string, releaseDefinitionUrl?: string, releaseName?: string, releaseUrl?: string) => void;
}